var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 666.66669,
    height: 666.66669,
    viewBox: "0 0 666.66669 666.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,666.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5000,0 H 0 V 5000 H 5000 V 0",
    style: {
      fill: "#f0f3c7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2505.9,3245 c -148.88,0 -270,-121.12 -270,-270 0,-148.88 121.12,-270 270,-270 148.88,0 270,121.12 270,270 0,148.88 -121.12,270 -270,270",
    style: {
      fill: "#f0f3c7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2725.9,2975 c 0,-121.5 -98.5,-220 -220,-220 -121.5,0 -220,98.5 -220,220 0,121.5 98.5,220 220,220 121.5,0 220,-98.5 220,-220 z m -800.82,-377.79 c 0,-780.27 260.04,-1112.01 580.82,-1112.01 320.78,0 580.82,331.74 580.82,1112.01 0,780.26 -580.82,1412.79 -580.82,1412.79 0,0 -580.82,-632.53 -580.82,-1412.79",
    style: {
      fill: "#1c3e5a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2208.9,3584.43 c 93.5,27.8 193.3,42.75 297,42.75 103.7,0 203.5,-14.95 297,-42.75 -147.3,262.6 -297,425.57 -297,425.57 0,0 -149.7,-162.97 -297,-425.57",
    style: {
      fill: "#14161f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1589.3,1442.9 610.6,243.2 c -101.9,122 -172,314.9 -204.4,566.8 l -406.2,-810",
    style: {
      fill: "#3fa9a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2809,1682.6 601.7,-239.7 -396.9,791.6 C 2980.1,1989.2 2910,1801.5 2809,1682.6",
    style: {
      fill: "#3fa9a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2715.32,1474.29 -9.42,65.91 h -400 l -9.42,-65.91 c -20.38,-4.34 -35.68,-22.41 -35.68,-44.09 0,-24.9 20.19,-45.1 45.1,-45.1 h 400 c 24.91,0 45.1,20.2 45.1,45.1 0,21.68 -15.3,39.75 -35.68,44.09",
    style: {
      fill: "#14161f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2505.9,2755 c -121.5,0 -220,98.5 -220,220 0,121.5 98.5,220 220,220 121.5,0 220,-98.5 220,-220 0,-121.5 -98.5,-220 -220,-220 z m 0,490 c -148.88,0 -270,-121.12 -270,-270 0,-148.88 121.12,-270 270,-270 148.88,0 270,121.12 270,270 0,148.88 -121.12,270 -270,270",
    style: {
      fill: "#3fa9a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 380.891,2800.59 c 1.332,-0.04 2.629,-0.2 3.968,-0.2 68.993,0 124.922,55.93 124.922,124.92 0,69 -55.929,124.92 -124.922,124.92 -12.472,0 -24.5,-1.88 -35.863,-5.28 0.059,1.84 0.141,3.67 0.141,5.53 0,93.17 -75.535,168.7 -168.711,168.7 -70.754,0 -131.2932,-43.57 -156.3557,-105.33 -7.3945,6.67 -15.48436,12.57 -24.0703,17.73 v -331.19 h 380.891 v 0.2",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4717.97,938.488 c 0.3,4.532 0.69,9.043 0.69,13.641 0,114.141 -92.53,206.671 -206.67,206.671 -23.62,0 -46.23,-4.16 -67.38,-11.46 -46.74,125.43 -167.56,214.79 -309.28,214.79 -155.68,0 -286.09,-107.83 -320.84,-252.85 -9.45,1.82 -19.18,2.85 -29.16,2.85 -84.69,0 -153.34,-68.65 -153.34,-153.329 0,-7.571 0.74,-14.961 1.79,-22.231 -70.97,-11.879 -125.12,-73.422 -125.12,-147.769 0,-82.852 67.16,-150 150,-150 h 1053.33 c 82.85,0 150,67.148 150,150 0,80.82 -63.97,146.527 -144.02,149.687",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 746.199,2735.64 c 63.414,16.35 110.332,73.76 110.332,142.28 0,81.25 -65.863,147.11 -147.105,147.11 -3.332,0 -6.59,-0.28 -9.863,-0.5 -1.219,92.21 -76.305,166.59 -168.805,166.59 -50.27,0 -95.387,-21.99 -126.32,-56.85 -34.239,27.33 -77.606,43.71 -124.825,43.71 -90.367,0 -166.73,-59.86 -191.6677,-142.08 -7.3398,2.45 -15.168,3.84 -23.332,3.84 -27.8867,0 -52.1406,-15.52 -64.6133,-38.4 v -270.52 h 746.199 v 4.82",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4970.73,2499.33 c 0.08,2.51 0.19,5.01 0.19,7.54 0,127.06 -103,230.07 -230.07,230.07 -96.49,0 -179.05,-59.42 -213.22,-143.65 -37.43,33.76 -86.99,54.33 -141.36,54.33 -111.21,0 -202.27,-86.01 -210.46,-195.12 -77.01,-2.53 -138.7,-65.59 -138.7,-143.22 0,-71.85 52.87,-131.18 121.8,-141.65 v -1.8 H 5000 v 339.45 c -10.03,-1.18 -19.83,-3.12 -29.27,-5.95",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4671.41,849.352 c -14.56,0 -28.6,-2.204 -41.87,-6.172 0.07,2.14 0.16,4.281 0.16,6.449 0,108.769 -88.18,196.951 -196.95,196.951 -82.59,0 -153.27,-50.869 -182.52,-122.971 -32.04,28.903 -74.46,46.5 -121.01,46.5 -95.2,0 -173.15,-73.621 -180.16,-167.027 -65.92,-2.16 -118.73,-56.141 -118.73,-122.59 0,-61.512 45.26,-112.301 104.26,-121.262 v -1.55 h 732.18 v 0.242 c 1.56,-0.051 3.07,-0.242 4.64,-0.242 80.54,0 145.83,65.289 145.83,145.84 0,80.539 -65.29,145.832 -145.83,145.832",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1449.56,1001.44 c -26.75,0 -52.23,-5.19 -75.75,-14.319 -12.72,107.179 -103.75,190.349 -214.36,190.349 -67.69,0 -128.06,-31.19 -167.669,-79.92 -52.722,64.17 -132.687,105.11 -222.226,105.11 -152.098,0 -276.524,-118.14 -286.719,-267.648 -95.992,-1.821 -173.281,-80.071 -173.281,-176.492 0,-83.758 58.347,-153.739 136.566,-171.93 v -4.738 h 996.769 v 0.339 c 2.23,-0.07 4.42,-0.339 6.67,-0.339 115.86,0 209.79,93.929 209.79,209.796 0,115.864 -93.93,209.792 -209.79,209.792",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4667.82,2351.08 c -2.79,0 -5.52,-0.24 -8.26,-0.42 -1.02,77.23 -63.9,139.53 -141.37,139.53 -42.1,0 -79.89,-18.42 -105.79,-47.62 -28.68,22.89 -65,36.61 -104.55,36.61 -75.68,0 -139.63,-50.13 -160.52,-119 -6.15,2.06 -12.7,3.22 -19.54,3.22 -34.02,0 -61.6,-27.58 -61.6,-61.6 0,-4.87 0.62,-9.58 1.69,-14.12 -5.86,1.16 -11.92,1.8 -18.12,1.8 -51.03,0 -92.4,-41.37 -92.4,-92.4 0,-51.03 41.37,-92.4 92.4,-92.4 h 648.86 v 4.03 c 53.11,13.7 92.41,61.78 92.41,119.17 0,68.04 -55.16,123.2 -123.21,123.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1559.72,742.57 c 0.24,3.59 0.55,7.149 0.55,10.801 0,90.391 -73.28,163.66 -163.67,163.66 -18.71,0 -36.61,-3.293 -53.35,-9.07 -37.02,99.329 -132.7,170.099 -244.94,170.099 -123.279,0 -226.552,-85.388 -254.076,-200.24 -7.48,1.442 -15.187,2.262 -23.093,2.262 -67.063,0 -121.426,-54.371 -121.426,-121.434 0,-5.996 0.578,-11.839 1.418,-17.609 -56.207,-9.398 -99.09,-58.141 -99.09,-117.019 0,-65.598 53.184,-118.79 118.789,-118.79 h 834.158 c 65.6,0 118.79,53.192 118.79,118.79 0,64.011 -50.66,116.05 -114.06,118.55",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2502.39,1476.77 c -76.18,0 -138.16,-61.98 -138.16,-138.16 0,-41.66 18.62,-78.98 47.87,-104.34 -21.01,24.25 -33.82,55.77 -33.82,90.29 0,76.18 61.98,138.16 138.16,138.16 34.52,0 66.04,-12.82 90.29,-33.82 -25.36,29.25 -62.68,47.87 -104.34,47.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2523.46,1441.64 c -68.54,0 -124.1,-55.56 -124.1,-124.1 0,-68.55 55.56,-124.11 124.1,-124.11 68.55,0 124.11,55.56 124.11,124.11 0,68.54 -55.56,124.1 -124.11,124.1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2355.9,1385.1 c -108.45,0 -196.67,-88.22 -196.67,-196.67 0,-59.3 26.5,-112.43 68.15,-148.52 -29.91,34.51 -48.15,79.38 -48.15,128.52 0,108.45 88.22,196.67 196.67,196.67 49.14,0 94.02,-18.24 128.53,-48.14 -36.09,41.64 -89.22,68.14 -148.53,68.14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2385.9,1335.1 c -97.57,0 -176.67,-79.1 -176.67,-176.67 0,-97.57 79.1,-176.66 176.67,-176.66 97.57,0 176.67,79.09 176.67,176.66 0,97.57 -79.1,176.67 -176.67,176.67",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2822.39,175.199 c -40.7,0 -73.8,-33.109 -73.8,-73.797 0,-22.2614 9.94,-42.2028 25.57,-55.7418 -11.22,12.9492 -18.07,29.789 -18.07,48.2304 0,40.6994 33.11,73.8084 73.81,73.8084 18.44,0 35.28,-6.847 48.23,-18.07 -13.54,15.633 -33.48,25.57 -55.74,25.57",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2833.65,156.441 c -36.62,0 -66.3,-29.691 -66.3,-66.3004 0,-36.6211 29.68,-66.3008 66.3,-66.3008 36.62,0 66.3,29.6797 66.3,66.3008 0,36.6094 -29.68,66.3004 -66.3,66.3004",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3119.45,76.7188 c 31.45,0 60.18,-11.6797 82.26,-30.8204 -23.09,26.6602 -57.1,43.6211 -95.06,43.6211 -56.77,0 -104.83,-37.789 -120.48,-89.5195 h 17.41 c 19.19,45.0508 63.89,76.7188 115.87,76.7188",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3125.85,57.5195 c -42.24,0 -79,-23.2109 -98.42,-57.5195 h 196.84 c -19.41,34.3086 -56.18,57.5195 -98.42,57.5195",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2329.98,388.391 c -40.13,0 -72.77,-32.641 -72.77,-72.77 0,-21.941 9.81,-41.601 25.22,-54.949 -11.07,12.769 -17.82,29.367 -17.82,47.558 0,40.122 32.64,72.762 72.77,72.762 18.18,0 34.79,-6.75 47.55,-17.812 -13.35,15.41 -33.01,25.211 -54.95,25.211",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2341.08,369.891 c -36.1,0 -65.37,-29.262 -65.37,-65.36 0,-36.109 29.27,-65.371 65.37,-65.371 36.1,0 65.37,29.262 65.37,65.371 0,36.098 -29.27,65.36 -65.37,65.36",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2488.74,204.84 c 37.86,0 72.44,-14.051 99.03,-37.09 -27.81,32.082 -68.74,52.5 -114.44,52.5 -83.56,0 -151.53,-67.969 -151.53,-151.5312 0,-24.7891 6.16,-48.0704 16.78,-68.7188 h 8.39 c -6.29,16.582 -9.76,34.5391 -9.76,53.3086 0,83.5624 67.97,151.5314 151.53,151.5314",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2496.45,181.719 c -75.18,0 -136.13,-60.938 -136.13,-136.1174 0,-16.0196 2.91,-31.3203 8,-45.6016 h 256.25 c 5.09,14.2813 8,29.582 8,45.6016 0,75.1794 -60.95,136.1174 -136.12,136.1174",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2127.37,685.891 c -76.18,0 -138.15,-61.969 -138.15,-138.161 0,-41.66 18.61,-78.98 47.87,-104.332 -21.01,24.243 -33.82,55.762 -33.82,90.282 0,76.191 61.97,138.16 138.15,138.16 34.52,0 66.05,-12.809 90.29,-33.82 -25.35,29.261 -62.68,47.871 -104.34,47.871",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2148.45,650.762 c -68.54,0 -124.11,-55.563 -124.11,-124.102 0,-68.539 55.57,-124.109 124.11,-124.109 68.54,0 124.1,55.57 124.1,124.109 0,68.539 -55.56,124.102 -124.1,124.102",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2024.13,363.781 c -108.45,0 -196.67,-88.222 -196.67,-196.672 0,-59.308 26.5,-112.4371 68.15,-148.527 -29.91,34.5078 -48.15,79.3868 -48.15,128.527 0,108.45 88.22,196.672 196.67,196.672 49.14,0 94.02,-18.242 128.53,-48.152 -36.09,41.652 -89.22,68.152 -148.53,68.152",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2230.8,137.109 c 0,97.571 -79.1,176.672 -176.67,176.672 -97.57,0 -176.67,-79.101 -176.67,-176.672 0,-55.3473 25.5,-104.7184 65.34,-137.109 h 222.66 c 39.85,32.3906 65.34,81.7617 65.34,137.109",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2715.52,1264.13 c -57.07,0 -103.5,-46.43 -103.5,-103.49 0,-31.21 13.95,-59.17 35.86,-78.16 -15.73,18.16 -25.33,41.77 -25.33,67.63 0,57.07 46.42,103.49 103.49,103.49 25.86,0 49.47,-9.59 67.63,-25.33 -18.99,21.91 -46.95,35.86 -78.15,35.86",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2731.3,1237.81 c -51.34,0 -92.96,-41.62 -92.96,-92.96 0,-51.34 41.62,-92.97 92.96,-92.97 51.35,0 92.97,41.63 92.97,92.97 0,51.34 -41.62,92.96 -92.97,92.96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2512.06,1083.13 c -193.41,0 -350.76,-157.349 -350.76,-350.759 0,-105.769 47.26,-200.531 121.54,-264.902 -53.33,61.551 -85.87,141.582 -85.87,229.23 0,193.41 157.35,350.761 350.76,350.761 87.65,0 167.68,-32.53 229.23,-85.87 -64.36,74.28 -159.12,121.54 -264.9,121.54",
    style: {
      fill: "#f1ad2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2565.57,993.949 c -174.02,0 -315.08,-141.07 -315.08,-315.09 0,-174.007 141.06,-315.078 315.08,-315.078 174.02,0 315.08,141.071 315.08,315.078 0,174.02 -141.06,315.09 -315.08,315.09",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2811.97,723.449 c -135.87,0 -246.4,-110.527 -246.4,-246.398 0,-74.301 33.2,-140.871 85.38,-186.082 -37.47,43.23 -60.32,99.453 -60.32,161.023 0,135.867 110.53,246.406 246.4,246.406 61.57,0 117.79,-22.859 161.03,-60.316 -45.22,52.18 -111.78,85.367 -186.09,85.367",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2849.56,660.809 c -122.24,0 -221.34,-99.098 -221.34,-221.348 0,-122.242 99.1,-221.34 221.34,-221.34 122.24,0 221.34,99.098 221.34,221.34 0,122.25 -99.1,221.348 -221.34,221.348",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.265a72f24bd30b09ba87d31d141e9012.svg";
export { ForwardRef as ReactComponent };